module.exports = __webpack_public_path__ + "img/engravingRingsize-2@2x.38977ca.webp";